<template>
  <div class="graph-container">
    <line-chart
      :series="series"
      :labels="labels"
      :x-axis="xAxis"
      :y-axis="yAxis"
      :colors="colors"
      :annotations="annotations"
      :animations="false"
    />
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import LineChart from "@/components/common/charts/LineChart.vue";
import { formatCwvMetric } from "@/components/web-perf/cwv/utils/utils";

export default {
  name: "MetricGraph",
  components: {
    VueApexCharts,
    LineChart,
  },
  props: {
    annotations: {
      type: Object,
      default: () => ({}),
    },
    metric: {
      type: String,
      default: "",
    },
    series: {
      type: Array,
      default: () => [],
    },
    labels: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      rumColors: {
        Mobile: "#0b42b9", // Darker blue for mobile
        Desktop: "#3f83f8", // Medium blue for desktop
        Tablet: "#a0c5ff", // Lighter blue for tablet
      },
      cruxColors: {
        Mobile: "#8649ff", // Darker purple for mobile
        Desktop: "#b794f4", // Medium purple for desktop
        Tablet: "#e3d0ff", // Lighter purple for tablet
      },
      xAxis: {
        type: "datetime",
        labels: {
          formatter: function (val) {
            return new Date(val).toLocaleDateString();
          },
        },
      },
      yAxis: [
        {
          labels: {
            formatter: (val) =>
              this.formatCwvMetric(val, this.metric.toUpperCase()),
          },
        },
      ],
      // yaxis: {
      //   min: 0,
      //   max: 100,
      //   forceNiceScale: false,
      // },
    };
  },
  computed: {
    colors() {
      if (!this.series || this.series.length === 0) return [];

      return this.series.map((series) => {
        const baseName = series.baseDeviceName || series.name;
        const isCrux = series.name.includes("(CrUX)");
        let deviceType = baseName.replace(" (CrUX)", "").trim();

        // Make device type matching more flexible
        deviceType = deviceType.toLowerCase();
        const colorPalette = isCrux ? this.cruxColors : this.rumColors;

        // Try to find a matching device type (case insensitive)
        const matchingKey = Object.keys(colorPalette).find(
          (key) => key.toLowerCase() === deviceType
        );

        // If no match found, try to determine device type from the name
        let color;
        if (matchingKey) {
          color = colorPalette[matchingKey];
        } else if (deviceType.includes("mobile")) {
          color =
            colorPalette["Mobile"] ||
            colorPalette[Object.keys(colorPalette)[0]];
        } else if (deviceType.includes("tablet")) {
          color =
            colorPalette["Tablet"] ||
            colorPalette[Object.keys(colorPalette)[2]];
        } else {
          // Default to desktop if no match found
          color =
            colorPalette["Desktop"] ||
            colorPalette[Object.keys(colorPalette)[1]];
        }

        return color;
      });
    },
  },
  methods: {
    formatCwvMetric,
  },
};
</script>

<style scoped>
.graph-container {
  border: 1px solid #e0e6ee;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.15);
  transform: translateY(0);
}
</style>
